import React, { useState } from "react"
import { Container, Form} from "reactstrap"
import { useFormik } from "formik"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../components/ResultHandler"
import FormButtonHandler from "../../../components/FormButtonHandler"
import { useResponse } from "../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../hooks/useGetInstence"
import { INSURANCE_REQUIRED_FIELDS } from "./CONSTANT"
import * as Yup from "yup"
import InsuranceForm from "./InsuranceForm"
import { editInsurance, getSingleInsurance } from "../../../api/insurance"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

INSURANCE_REQUIRED_FIELDS.forEach((f) => {
    initialValues[f.key] = TYPES[f.type] || "";
    
    if (f.type == "file") {
        FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
            "This Field Is Required"
        );
    } else if (f.type == "select" && f.isMulti) {
        FIELDS_VALIDATION[f.key] = Yup.array();
    } else {
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
    }
});

const EditInsurance = () => {
    let navigate = useHistory()
    const { t } = useTranslation()
    const {id: insuranceId} = useParams()
    const [editedInsurance, setEditedInsurance] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getSingleInsurance,
        insuranceId,
        response => {
            setEditedInsurance({...response.data.data})
        }
    )

    const { setData, loading, error, success } = useResponse(editInsurance, () => {
        navigate.goBack()
    })
    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {...editedInsurance},
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: (data) => {
            const fullData = {...data, insurance_active: JSON.parse(data.insurance_active)}
            setData({ type: "edit", id: insuranceId, data:fullData })
        },
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Insurance")}
                        breadcrumbItem={t("btns.Edit") + " " + t("Insurance")}
                    />
                    
                        {editedInsurance && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <InsuranceForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>
                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditInsurance